import { API_ORIGIN } from '../config'
const API_BASE = `${API_ORIGIN}/api`
const SERVER_BASE = `${API_ORIGIN}`

export async function generateReport(parkId, payload) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/reports/generate`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({}))
    throw new Error(err.error || 'Error al generar el reporte')
  }
  const data = await response.json()
  return { ...data, downloadUrl: `${SERVER_BASE}${data.downloadUrl}` }
}

export async function getReportHistory(parkId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/reports/history`)
  if (!response.ok) throw new Error('Error al obtener el historial')
  const data = await response.json()
  return data.map((r) => ({ ...r, downloadUrl: `${SERVER_BASE}${r.downloadUrl}` }))
}

export async function deleteReport(parkId, reportId) {
  const response = await fetch(`${API_BASE}/parks/${parkId}/reports/${reportId}`, {
    method: 'DELETE',
  })
  if (!response.ok) throw new Error('Error al eliminar el reporte')
  return response.json()
}